import * as React from "react";
import Button from "../button";

/** 간단한 className 머지 */
function cn(...xs: Array<string | false | undefined>) {
  return xs.filter(Boolean).join(" ");
}

/** 스크롤 내려가면 elevation 주기 */
function useElevatedOnScroll(threshold = 2) {
  const [elevated, setElevated] = React.useState(false);
  React.useEffect(() => {
    const onScroll = () => setElevated(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);
  return elevated;
}

type AppBarProps = {
  title?: string;
  /** 좌측 뒤로가기 사용 여부 (기본 true) */
  backButton?: boolean;
  /** 투명 배경(콘텐츠 위에 overlay) */
  transparent?: boolean;
  /** 우측 액션 영역 */
  right?: React.ReactNode;
  /** 고정 높이(기본 56) */
  height?: number;
  className?: string;
  /** 커스텀 클릭 핸들러(뒤로가기 대신) */
  onBack?: () => void;
};

export default function CloseAppBar({
  title,
  transparent = false,
  height = 56,
  className,
  onBack
}: AppBarProps) {
  const elevated = useElevatedOnScroll(2);


  return (
    <header
      className={cn(
        "sticky top-0 z-40",
        transparent ? "border-transparent" : "bg-white/90 backdrop-blur",
        !transparent && (elevated ? "shadow-sm" : "shadow-none"),
        className
      )}
      // iOS 노치 대응: 안전하게 safe-area 상단 패딩 더해줌
      style={{
        paddingTop: "var(--safe-area-inset-top)",
      }}
    >
      <div
        className="w-full flex-row-between px-4"
        style={{
          height: height
        }}
      >
        {/* Left */}
        <div className="w-5" />


        {/* Center Title */}
        {title ? (
          <h1 className="text-[16px] font-bold text-black text-center">
            {title}
          </h1>
        ) : null}


        {/* Right actions */}
        <Button
          className="p-0"
          label=""
          onClick={onBack}
        >
          <img className="w-[20px] h-[20px]" src="/icons/ic-close.webp" />
        </Button>
      </div>
      {/* safe bottom border gradient for transparent bars if needed */}
      {transparent ? <div className="h-px bg-gradient-to-r from-black/10 to-transparent" /> : null}
    </header>
  );
}